import { getEnvSettings } from 'src/admin/core';
import { v4 as uuidv4 } from 'uuid';

const DEVICE_ID_STORAGE_KEY = 'placebet_device_id';

const getSubFromToken = (): string | null => {
  try {
    const raw = sessionStorage.getItem(getEnvSettings().OIDC_STORAGE_KEY);
    if (!raw) return null;
    const storedToken = JSON.parse(raw);
    const token = storedToken?.access_token;
    if (!token) return null;

    const base64Url = token.split('.')[1];
    if (!base64Url) return null;
    const base64 = base64Url.replaceAll('-', '+').replaceAll('_', '/');
    const jsonPayload = decodeURIComponent(
      [...globalThis.atob(base64)]
        .map((c) => '%' + ('00' + c.codePointAt(0)?.toString(16)).slice(-2))
        .join('')
    );
    const payload = JSON.parse(jsonPayload);
    return payload?.sub || null;
  } catch (error) {
    console.error('[Fingerprint Override] Error al obtener el sub desde el token:', error);
    return null;
  }
};

export const getFingerprint = async (force = false) => {
  // NOTA TEMPORAL: Intervención para retornar el 'sub' (ID de usuario) del usuario logueado en lugar del fingerprint físico.
  // La lógica original se conserva intacta a continuación y actúa como fallback en caso de no haber un usuario logueado.
  const loggedUserSub = getSubFromToken();
  if (loggedUserSub) {
    console.log('[Fingerprint Override] Usando sub del usuario logueado como fingerprint:', loggedUserSub);
    return loggedUserSub;
  }
  else {
    console.log('[Fingerprint Override] No se encontró sub del usuario logueado');
    throw new Error('No se encontró sub del usuario logueado');
  }

  // Check if we have a stored device ID
  const cachedDeviceId = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
  if (cachedDeviceId && !force) {
    console.log('[Fingerprint] Usando ID guardado en caché:', cachedDeviceId);
    return cachedDeviceId;
  }

  // Try to get fingerprint from URL first
  const params = new URLSearchParams(globalThis.location?.search || '');
  const urlDeviceId = params.get('deviceId')?.trim();

  if (urlDeviceId) {
    console.log('[Fingerprint] Usando ID desde URL:', urlDeviceId);
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, urlDeviceId);
    return urlDeviceId;
  }

  let visitorId = '';

  try {
    console.log('[Fingerprint] Intentando obtener ID con FingerprintJS Pro...');
    // Try FingerprintJS Pro first
    const { load } = await import('@fingerprintjs/fingerprintjs-pro');
    const apiKey = getEnvSettings().REACT_APP_PB_FINGERPRINT_PRO_KEY || 'UQreLvVEdQFIupF6P2FP';
    const fp = await load({ apiKey });
    const result = await fp.get();
    visitorId = result.visitorId;
    console.log('[Fingerprint] ID obtenido con Pro:', visitorId);
  } catch (error) {
    console.error('[Fingerprint] Error al obtener ID de FingerprintJS Pro:', error);
    throw new Error('Error al inicializar FingerprintJS Pro: ' + (error instanceof Error ? error.message : String(error)));
  }

  if (visitorId) {
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, visitorId);
  }

  return visitorId;
};
